import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "Nahya Nengsih",
    role: "Local Guide Level 3",
    text: "Sapinya bagus-bagus dan sehat. Prosesnya cepat, pelayanannya ramah banget. Puas sekali transaksi di sini, sukses selalu Ustadz Hafizt & tim Toyibah Aqiqah!",
    rating: 5,
    img: "/Nahya_Nengsih.jpeg",
  },
  {
    name: "Thomas Habibi",
    role: "",
    text: "Pelayanan amanah, barakah, dan sangat profesional. Mulai dari pemesanan sampai pengantaran semuanya lancar. Highly recommended untuk aqiqah & qurban!",
    rating: 5,
    img: "/Thomas_Habibi.jpeg",
  },
  {
    name: "Abd Rahman",
    role: "Local Guide",
    text: "Menjelang Idul Adha, saya survey langsung ke kandang Toyibah Aqiqah. MasyaAllah, hewannya terawat dan pelayanannya super istimewa. Kandang sendiri, bersih, dan terpercaya!",
    rating: 5,
    img: "/Abd_Rahman.jpeg",
  },
];

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="py-20 md:py-24 px-6 relative overflow-hidden bg-gradient-to-b from-[#FFFBF9] via-[#FFF7F4] to-[#FFFBF9] pt-28 scroll-mt-20"
    >
      {/* 🌸 Decorative Background */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 1L12 23M1 12L23 12' stroke='%23FF8A65' stroke-width='0.4'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
        }}
      />

      {/* 🌈 Soft Gradient Blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#FFC4B2]/40 blur-[100px] rounded-full opacity-50" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#58B09C]/30 blur-[100px] rounded-full opacity-40" />

      <div className="max-w-6xl mx-auto relative z-10">
        {/* 🌟 Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-20"
        >
          <h2
            className="text-3xl md:text-5xl font-extrabold text-[#333] mb-4"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Kata <span className="text-[#FF8A65]">Mereka</span> Tentang Kami
          </h2>
          <p className="text-[#777] text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Cerita nyata dari para pelanggan yang telah merasakan layanan
            terbaik dan penuh keberkahan dari{" "}
            <span className="font-semibold text-[#FF8A65]">
              Toyibah Aqiqah Jabodetabek
            </span>
            .
          </p>
        </motion.div>

        {/* 🎠 MOBILE CAROUSEL */}
        <div className="md:hidden flex overflow-x-auto snap-x snap-mandatory scroll-smooth gap-6 pb-6 hide-scrollbar">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              className="snap-center min-w-[85%] max-w-[85%] flex-shrink-0 bg-white/90 backdrop-blur-sm border border-[#FFD8C8]/50 rounded-3xl p-8 shadow-[0_6px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_25px_rgba(255,138,101,0.15)] transition-all duration-500 mx-auto"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <Quote className="absolute top-6 right-6 text-[#FFC4B2] w-8 h-8 opacity-40" />
              <div className="flex flex-col items-center text-center mb-5 w-full">
                <img
                  src={review.img}
                  alt={review.name}
                  className="w-16 h-16 rounded-full object-cover shadow-md mb-3 border-2 border-[#FF8A65]/40"
                  loading="lazy"
                />
                <h3 className="text-lg font-semibold text-[#333]">
                  {review.name}
                </h3>
                {review.role && (
                  <p className="text-sm text-[#888]">{review.role}</p>
                )}
              </div>
              <div className="flex justify-center gap-1 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-yellow-400 fill-yellow-400"
                  />
                ))}
              </div>
              <p className="text-[#555] italic leading-relaxed text-sm mb-2">
                "{review.text}"
              </p>
            </motion.div>
          ))}
        </div>

        {/* 💻 DESKTOP GRID */}
        <div className="hidden md:grid grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="relative group bg-white/90 backdrop-blur-sm border border-[#FFD8C8]/50 rounded-3xl p-8 shadow-[0_6px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_25px_rgba(255,138,101,0.15)] hover:-translate-y-2 transition-all duration-500"
            >
              <Quote className="absolute top-6 right-6 text-[#FFC4B2] w-8 h-8 opacity-40" />
              <div className="flex flex-col items-center text-center mb-5">
                <img
                  src={review.img}
                  alt={review.name}
                  className="w-16 h-16 rounded-full object-cover shadow-md mb-3 border-2 border-[#FF8A65]/40"
                  loading="lazy"
                />
                <h3 className="text-lg font-semibold text-[#333]">
                  {review.name}
                </h3>
                {review.role && (
                  <p className="text-sm text-[#888]">{review.role}</p>
                )}
              </div>
              <div className="flex justify-center gap-1 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 md:w-5 md:h-5 text-yellow-400 fill-yellow-400"
                  />
                ))}
              </div>
              <p className="text-[#555] italic leading-relaxed text-sm md:text-base mb-2">
                "{review.text}"
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
